/** @format */

import {
	QueryClient,
	QueryClientProvider
} from "@tanstack/react-query";
import "antd/dist/reset.css";
import { useEffect } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { SWRConfig } from "swr";
import App from "./App";
import "./index.css";
import store from "./redux";
import { setAppProps } from "./redux/appPropsReducer/actions";
import { localStorageProvider } from "./services/LocalStorageProvider";

declare global {
  interface Window {
    recaptchaOptions?: {
      enterprise: boolean;
    };
  }
}

window.recaptchaOptions = {
  enterprise: true,
};

export const queryClient = new QueryClient();

function Index() {
  useEffect(() => {
    fetch(process.env.PUBLIC_URL + "/appProps.json")
      .then((response) => response.json())
      .then((data) => {
        const WLO = window.location.origin;
        Object.entries(data).forEach(([key, value]) => {
          if (typeof value === "string") {
            data[key] = value.replace("__WINDOW_LOCATION_ORIGIN__", WLO);
          }
        });

        store.dispatch(setAppProps(data));
        console.log("data", data);
      });
  }, []);
  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root")!);
root.render(
  <Provider store={store}>
    <SWRConfig value={{ provider: localStorageProvider }}>
      <QueryClientProvider client={queryClient}>
        <Index />
      </QueryClientProvider>
    </SWRConfig>
  </Provider>
);
